import { Dashboard } from '@akin-home/amplify';
import { DashboardModel } from '@akin-home/dashboards';

export const dashboardGraphqlToModel = (
  dashboard: Dashboard
): DashboardModel => {
  return {
    ...dashboard,
    id: dashboard.id as string,
    name: dashboard.name || '',
    description: dashboard.description || '',
    device_type: dashboard.device_type || undefined,
    user_id: dashboard.user_id || undefined,
    layout: dashboard.layout ? JSON.parse(dashboard.layout) : [],
  };
};
